import moment from "moment";

export class FormatDate {
    public static getFormattedDateES(date: Date): string {
        return moment(date)
            .locale("es")
            .format("DD MMMM yyyy");
    }
    public static getFormattedMonthES(date: Date): string {
        return moment(date)
            .locale("es")
            .format("MMMM");
    }
    public static getFormattedDayMonthES(date: Date): string {
        return moment(date)
            .locale("es")
            .format("DD MMM");
    }
    public static getFormattedDayMonthYearES(date: Date | string): string {
        return moment(date)
            .locale("es")
            .format("DD MMM yyyy");
    }
    public static getFormattedDatePT(date: Date): string {
        return moment(date)
            .locale("pt")
            .format("DD MMMM yyyy");
    }
    public static getFormattedDayMonthPT(date: Date): string {
        return moment(date)
            .locale("pt")
            .format("DD MMM");
    }
    public static getFormattedDayMonthYearPT(date: Date): string {
        return moment(date)
            .locale("pt")
            .format("DD MMM yyyy");
    }
}
